export enum PAGE_LENGTH {
  XSMALL = 4,
  SMALL = 10,
  MEDIUM = 25,
  LARGE = 50,
  XLARGE = 100
}

export const SEARCH_COOLDOWN = 350;
